export const formatWebinarTimeRange = (startTime, duration) => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const start = new Date(startTime)
  const end = new Date(start.getTime() + duration * 60000)

  const startLocal = new Date(
    start.toLocaleString('en-US', { timeZone: userTimeZone })
  )
  const endLocal = new Date(
    end.toLocaleString('en-US', { timeZone: userTimeZone })
  )

  const formatTime = (date) => {
    let hours = date.getHours()
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const period = hours >= 12 ? 'PM' : 'AM'

    hours = hours % 12
    hours = hours ? hours : 12

    return `${hours}:${minutes} ${period}`
  }

  return `${formatTime(startLocal)} - ${formatTime(endLocal)}`
}

export const disablePanelistAccess = (startTime: string): boolean => {
  const startDateTime = new Date(startTime)
  const currentTime = new Date()

  const diffInMinutes =
    (startDateTime.getTime() - currentTime.getTime()) / (1000 * 60)

  return diffInMinutes > 30
}
